import { useHeroHeaderView } from "@/components/hero-header/HeroHeaderViewProvider"
import { useAutoScrollContainer } from "@/providers/AutoScrollContainerProvider"

export function useScrollToTop() {
  const { available: heroHeaderAvailable, scrollToTop: scrollHeroHeaderToTop } =
    useHeroHeaderView()
  const { available: scrollContainerAvailable, ref: scrollContainerRef } =
    useAutoScrollContainer()

  function scrollToTop() {
    if (scrollContainerAvailable) {
      scrollContainerRef?.current?.scrollTo(0, 0)

      return
    }

    if (heroHeaderAvailable) {
      scrollHeroHeaderToTop()

      return
    }

    window.scrollTo(0, 0)
  }

  return scrollToTop
}
